<template>
  <div>
    <div class="d-flex">
      <v-btn
        :disabled="disabled"
        @click="printReport"
        :width="$vuetify.breakpoint.xs ? 100 : 120"
        color="primary"
        class="light--text text-capitalize text-end me-2 me-sm-3"
        :small="$vuetify.breakpoint.xs"
      >
        <v-icon class="me-1" :small="$vuetify.breakpoint.xs">mdi-file-document</v-icon>Print
      </v-btn>

      <v-btn
        :disabled="disabled"
        @click="exportExcel"
        :width="$vuetify.breakpoint.xs ? 100 : 120"
        color="primary"
        :small="$vuetify.breakpoint.xs"
        class="light--text text-capitalize text-end me-2 me-sm-3"
      >
        <v-icon size="20" class="me-1" :small="$vuetify.breakpoint.xs">mdi-export</v-icon>Export
      </v-btn>
    </div>

    <div v-show="false">
      <div id="printMe">
        <div v-for="(item, index) in reportListGrouped" :key="index">
          <h2>{{ item.category.nameEn }}</h2>
          <table border="1" style="border-collapse: collapse; width: 250mm">
            <tr>
              <th>Sl.No</th>
              <th>Meal</th>
              <th>Count</th>
            </tr>

            <tr v-for="(menu, indexOrder) in item.menus" :key="indexOrder">
              <td>{{ indexOrder + 1 }}</td>
              <td>
                <span v-if="menu.menu">{{ menu.menu.nameEn }}</span>
              </td>
              <td>{{ menu.count }}</td>
            </tr>
          </table>

          <p style="page-break-after: always">&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import VueLodash from "vue-lodash";
import Vue from "vue";
import lodash from "lodash";
Vue.use(VueLodash, { name: "custom", lodash: lodash });
import { Utils } from "../../utils/utils";
export default Vue.extend({
  props: {
    date: { require: true },
    reportList: { require: true },
    disabled: { require: true },
    headers: { require: true },
    meanInfos: { require: true },
  },

  data() {
    return {
      menu: false,
      loading: false,
      lodash: lodash,
      errorLog: [],
      showErrorDialog: false,
      btnloading: false,
      reportListGrouped: [],
      reportGeneratedDate: [],
    };
  },
  created() {
    // this.getOrderMealDetailsByDate();
    this.reportListGrouped = new Array();
    this.reportList.forEach(element => {
      let existingCategory = this.reportListGrouped.find(x => x.category.nameEn == element.category.nameEn);
      if (existingCategory) {
        existingCategory.menus.push({ menu: element.menu, count: element.count });
      } else {
        let item = { category: element.category };
        item.menus = new Array();
        item.menus.push({ menu: element.menu, count: element.count });
        this.reportListGrouped.push(item);
      }
    });
  },
  methods: {
    exportExcel() {
      Utils.htmlToExcel("printMe", "Order");
    },
    getTotalValue(item) {
      let total = 0;

      if (item.isParent && !item.isCatefory) {
        if (item.meanInfo) {
          item.meanInfo.forEach(element => {
            element.forEach(item => {
              total = total + item.count;
            });
          });
        }
      } else {
        total = item.meanInfo.map(x => x.count).reduce((a, b) => a + b, 0);
      }

      return total;
    },
    printReport() {
      const divToPrint = document.getElementById("printMe");
      const newWin = window.open("", "Print-Window");
      newWin.document.open();

      newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + "</body></html>");

      newWin.document.close();
      newWin.focus();
      newWin.print();
      setTimeout(function() {
        newWin.close();
      }, 10);
    },
  },
  computed: {
    formatDate() {
      return this.date ? moment(this.date).format("DD/MM/YYYY") : "";
    },
    reportWithSno() {
      if (this.reportList == null) return [];
      return this.reportList.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
});
</script>

<style scoped>
@media print {
  .pagebreak {
    page-break-before: always;
  } /* page-break-after works, as well */
}
</style>
